export const isStructuredLayout = (layoutVersion: string) => {
  if (!layoutVersion) return false;
  let isStoryV5 = false;
  if (layoutVersion !== "latest") {
    const parsed = Number(layoutVersion[0]);
    if (!isNaN(parsed) && parsed >= 5) isStoryV5 = true;
  }
  return isStoryV5;
};
